import { render, staticRenderFns } from "./StarshipModifications.vue?vue&type=template&id=6c29e383&lang=pug&"
import script from "./StarshipModifications.vue?vue&type=script&lang=ts&"
export * from "./StarshipModifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports